import Image from "next/image";
import Link from "next/link";

export default function ProductCard({ title, image, href, price, stock }) {
  const inStock = Number(stock) > 0;

  return (
    <Link
      href={href}
      className="
        group block w-full
        rounded-2xl bg-white dark:bg-zinc-900
        shadow-md border border-gray-200 dark:border-zinc-700
        overflow-hidden
        transition
        hover:shadow-lg
      "
    >
      <div className="relative aspect-square bg-gray-50 dark:bg-zinc-800 overflow-hidden">
        <Image
          src={image}
          alt={title}
          fill
          unoptimized
          className="object-cover transition-transform duration-300 group-hover:scale-105"
        />

        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/40 to-transparent" />

        <div className="absolute top-2 right-2">
          <span
            className={`
              inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold shadow-sm
              ${inStock
                ? "bg-green-100 text-green-800 dark:bg-green-900/70 dark:text-green-100"
                : "bg-red-100 text-red-800 dark:bg-red-900/70 dark:text-red-100"}
            `}
          >
            {inStock ? `Készleten: ${stock} db` : "Nincs készleten"}
          </span>
        </div>
      </div>

      <div className="px-3 py-3 space-y-1">
        <div className="text-sm font-medium text-gray-800 dark:text-gray-100 line-clamp-2 min-h-[2.5rem]">
          {title}
        </div>

        {price && (
          <div className="text-sm font-semibold text-gray-900 dark:text-gray-50">
            {price}
          </div>
        )}
      </div>
    </Link>
  );
}